<template>
  <div class="dash-item dash-calendar" id="calendar">
    <div :class="{ 'pc-calendar-shadow' : pcDisp }">
      <div id="calendar-mobile" v-show="!pcDisp">
        <calendar-filter :toggleCalendarSwitch="toggleCalendarSwitch"
                         :toggleCalendar="toggleCalendar"
                         :toggleFilterImage="toggleFilterImage"
                         :mainCalendar="mainCalendar"
                         :checkSwitch="checkSwitch"
                         :nextPage="nextPage"
                         :calendarDayDisp="calendarDayDisp"
                         :calendarMonthDisp="calendarMonthDisp"
                         :filterImageDisp="filterImageDisp"
                         :filterImage="filterImage"
                         :days="days"
                         :selectedDay="selectedDay"
                         :selectedDate="selectedDate"
                         :month="month"
                         :selectedMonth="selectedMonth"
                         :selectedYear="selectedYear"
                         :setAddDate="setAddDate"
                         :setAddMonth="setAddMonth"
                         :nowLang="app.nowLang" />
        <calendar-menu  :toggleCalendar="toggleCalendar"
                        :calendarTab1Disp="calendarTab1Disp"
                        :calendarTab2Disp="calendarTab2Disp"
                        :calendarTab3Disp="calendarTab3Disp"
                        :calendarTab4Disp="calendarTab4Disp"
                        :filterImage="filterImage"
                        :btnFilter="btnFilter"
                        :setBtnFilter="setBtnFilter"
                        :foundCalendar="foundCalendar" />
      </div>
      <div v-show="pcDisp">
        <div class="box-header-pc">
          <div class="header-left">
            <div class="rec bg-color-skin"></div>
          </div>
          <div class="header-center color-skin"> {{ app.home[app.nowLang].activity }} </div>
        </div>
        <calendar-filter-pc :toggleCalendarSwitch="toggleCalendarSwitch"
                            :toggleCalendar="toggleCalendar"
                            :checkSwitch="checkSwitch"
                            :selectedDate="selectedDate"
                            :month="month"
                            :selectedMonth="selectedMonth"
                            :btnFilter="btnFilter"
                            :setBtnFilter="setBtnFilter"
                            :calendarDayDisp="calendarDayDisp"
                            :nowLang="app.nowLang" />
      </div>
      <main-calendar  v-show="mainCalendar || pcDisp"
                            :calendarDayDisp="calendarDayDisp"
                            :calendarMonthDisp="calendarMonthDisp"
                            :currentYear="currentYear"
                            :currentMonth="currentMonth"
                            :currentDate="currentDate"
                            :selectingYear="selectingYear"
                            :selectingMonth="selectingMonth"
                            :setSelectMonth="setSelectMonth"
                            :setSelectYear="setSelectYear"
                            :setSelectDate="setSelectDate"
                            :totalWeek="totalWeek"
                            :days="days"
                            :month="month"
                            :checkCalendarMain="checkCalendarMain"
                            :calArrWeek="calArrWeek"
                            :checkCurrentDay="checkCurrentDay"
                            :checkSelectedDay="checkSelectedDay"
                            :checkCurrentMonth="checkCurrentMonth"
                            :checkSelectedMonth="checkSelectedMonth"
                            :pcDisp="pcDisp"
                            :nowLang="app.nowLang"
                            :disableCalendarYearButton="disableCalendarYearButton"
                            :autoFocusCalendarTab="autoFocusCalendarTab"
                            :calendarTab1="calendarTab1"
                            :calendarTab2="calendarTab2"
                            :calendarTab3="calendarTab3"
                            :calendarTab4="calendarTab4"
                            :checkCalendarHoliday="checkCalendarHoliday"
                            :traditionHoliday="traditionHoliday" />
      <div v-show="pcDisp">
        <calendar-menu-pc :toggleCalendar="toggleCalendar"
                          :calendarTab1Disp="calendarTab1Disp"
                          :calendarTab2Disp="calendarTab2Disp"
                          :calendarTab3Disp="calendarTab3Disp"
                          :calendarTab4Disp="calendarTab4Disp"
                          :foundCalendar="foundCalendar" />
      </div>

      <calendar-tab1  v-show="calendarTab1Disp || pcCalendarTab1Default"
                      :calendarTab1="calendarTab1"
                      :filterCalendarTab="filterCalendarTab"
                      :nowLang="app.nowLang" />
      <calendar-tab2  v-show="calendarTab2Disp"
                      :calendarTab2="calendarTab2"
                      :filterCalendarTab="filterCalendarTab"
                      :nowLang="app.nowLang" />
      <calendar-tab3  v-show="calendarTab3Disp"
                      :calendarTab3="calendarTab3"
                      :filterCalendarTab="filterCalendarTab"
                      :nowLang="app.nowLang" />
      <calendar-tab4  v-show="calendarTab4Disp"
                      :calendarTab4="calendarTab4"
                      :filterCalendarTab="filterCalendarTab"
                      :selectedDate="selectedDate"
                      :selectedMonth="selectedMonth"
                      :selectedYear="selectedYear"
                      :postCalendarTab4="postCalendarTab4"
                      :deleteCalendarTab4="deleteCalendarTab4"
                      :postCalendarTab4Checked="postCalendarTab4Checked"
                      :nowLang="app.nowLang"
                      :checkCalendarMain="checkCalendarMain" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import moment from 'moment'
import _ from 'lodash'
import * as types from 'store/modules/calendar/mutation-types'
import mainCalendar from 'components/calendar/main_calendar'
import CalendarFilter from 'components/calendar/calendar_filter'
import CalendarMenu from 'components/calendar/calendar_menu'
import CalendarFilterPc from 'components/calendar/calendar_filter_pc'
import CalendarMenuPc from 'components/calendar/calendar_menu_pc'
import calendarTab1 from 'components/calendar/calendar_tab1'
import calendarTab2 from 'components/calendar/calendar_tab2'
import calendarTab3 from 'components/calendar/calendar_tab3'
import calendarTab4 from 'components/calendar/calendar_tab4'

export default {
  name: 'calendar',
  data () {
    return {
      store: this.$store,
      app: this.$parent.$parent.$parent.$parent,
      checkSwitch: true,
      traditionHoliday: ''
    }
  },
  created () {
    this.receivedCalendarYear({year: this.selectingYear, getDescHoliday: this.getDescHoliday})
  },
  props: [ 'pcDisp' ],
  watch: {
    pcDisp () {
      if (!this.calendarTab1Disp && !this.calendarTab2Disp && !this.calendarTab3Disp && !this.calendarTab4Disp && this.pcDisp) {
        return this.$store.commit(types.SET_CALENDAR_DISP, 'calendarTab1Disp')
      }
    },
    calendarSwitch () {
      this.checkSwitch = this.calendarSwitch
    },
    selectingYear () {
      this.traditionHoliday = ''
      this.receivedCalendarYear({year: this.selectingYear, getDescHoliday: this.getDescHoliday})
    },
    selectingMonth () {
      this.getDescHoliday()
    }
  },
  computed: {
    pcCalendarTab1Default () {
      if (!this.calendarTab1Disp && !this.calendarTab2Disp && !this.calendarTab3Disp && !this.calendarTab4Disp && this.pcDisp) {
        return this.$store.commit(types.SET_CALENDAR_DISP, 'calendarTab1Disp')
      }
    },
    calendarDayDisp () {
      return this.calendarSwitch
    },
    calendarMonthDisp () {
      return !this.calendarSwitch
    },
    totalWeek () {
      return Math.ceil((this.firstDate + this.sumDayInMonth) / 7)
    },
    firstDate () {
      return Number(moment(moment().format(this.selectingYear + '-' + _.padStart(this.selectingMonth, 2, '0') + '-01')).format('e'))
    },
    sumDayInMonth () {
      return moment(moment().format(this.selectingYear + '-' + _.padStart(this.selectingMonth, 2, '0') + '-01')).daysInMonth()
    },
    ...mapGetters({
      btnFilter: types.GET_BTN_FILTER,
      foundCalendar: types.GET_FOUND_CALENDAR,
      currentYear: types.GET_CURRENT_YEAR,
      currentMonth: types.GET_CURRENT_MONTH,
      currentDate: types.GET_CURRENT_DATE,
      currentDay: types.GET_CURRENT_DAY,
      selectingYear: types.GET_SELECTING_YEAR,
      selectingMonth: types.GET_SELECTING_MONTH,
      selectedYear: types.GET_SELECTED_YEAR,
      selectedMonth: types.GET_SELECTED_MONTH,
      selectedDate: types.GET_SELECTED_DATE,
      selectedDay: types.GET_SELECTED_DAY,
      days: types.GET_DAYS,
      month: types.GET_MONTH,
      nextPage: types.GET_NEXT_PAGE,
      filterImage: types.GET_FILTER_IMAGE,
      filterImageDisp: types.GET_FILTER_IMAGE_DISP,
      mainCalendar: types.GET_MAIN_CALENDAR,
      calendarTab1Disp: types.GET_CALENDAR_TAB1_DISP,
      calendarTab2Disp: types.GET_CALENDAR_TAB2_DISP,
      calendarTab3Disp: types.GET_CALENDAR_TAB3_DISP,
      calendarTab4Disp: types.GET_CALENDAR_TAB4_DISP,
      calendarSwitch: types.GET_CALENDAR_SWITCH,
      disableCalendarYearButton: types.GET_DISABLE_CALENDAR_YEAR_BUTTON,
      calendarTab1: types.GET_CALENDAR_TAB1,
      calendarTab2: types.GET_CALENDAR_TAB2,
      calendarTab3: types.GET_CALENDAR_TAB3,
      calendarTab4: types.GET_CALENDAR_TAB4,
      calendarMain: types.GET_CALENDAR_MAIN,
      calendarHoliday: types.GET_CALENDAR_HOLIDAY
    })
  },
  methods: {
    checkCalendarMain (date, month) {
      let selectingMonth = (typeof month !== 'undefined') ? month : this.selectingMonth
      const dayArr = this.calendarMain.month[selectingMonth - 1]
      // return (date) ? ((dayArr[date - 1].tab1 && this.btnFilter.tab1) ||
      //                  (dayArr[date - 1].tab2 && this.btnFilter.tab2) ||
      //                  (dayArr[date - 1].tab3 && this.btnFilter.tab3) ||
      //                  (dayArr[date - 1].tab4 && this.btnFilter.tab4)) : false
      if (date > 0) {
        return ((dayArr[date - 1].tab1 && this.btnFilter.tab1) ||
                (dayArr[date - 1].tab2 && this.btnFilter.tab2) ||
                (dayArr[date - 1].tab3 && this.btnFilter.tab3) ||
                (dayArr[date - 1].tab4 && this.btnFilter.tab4))
      } else if (date === 0) {
        let _this = this
        let rowIndex = dayArr.map(function (day) {
          return ((day.tab1 && _this.btnFilter.tab1) ||
                  (day.tab2 && _this.btnFilter.tab2) ||
                  (day.tab3 && _this.btnFilter.tab3) ||
                  (day.tab4 && _this.btnFilter.tab4))
        }).indexOf(true)
        return (rowIndex > -1)
      } else {
        return false
      }
    },
    checkCalendarHoliday (date) {
      const holidayFilter = this.calendarHoliday.rows.filter(dataFilter => (parseInt(dataFilter.date) === date && parseInt(dataFilter.month) === this.selectingMonth))
      let typeWork = ''
      let holidayColor = ''
      if (holidayFilter.length > 0) {
        typeWork = holidayFilter[0].typwork
        if (typeWork === 'T') { // tradition
          holidayColor = 'date-green'
        } else if (typeWork === 'S') { // shutdown
          holidayColor = 'date-blue'
        } else if (typeWork === 'H') { // holiday
          holidayColor = 'date-red'
        } else { // others
          holidayColor = 'date-grey'
        }
      }
      return holidayColor
    },
    checkCurrentDay (day) {
      return (this.currentMonth === this.selectingMonth &&
             this.currentYear === this.selectingYear &&
             this.currentDate === day)
    },
    checkSelectedDay (day) {
      return (this.selectedMonth === this.selectingMonth &&
             this.selectedYear === this.selectingYear &&
             this.selectedDate === day)
    },
    checkCurrentMonth (month) {
      return (this.currentMonth === month &&
             this.currentYear === this.selectingYear)
    },
    checkSelectedMonth (month) {
      return (this.selectedMonth === month &&
             this.selectedYear === this.selectingYear)
    },
    calArrWeek (week) {
      var dayStartInRow = 1 + (week - 1) * 7
      if (week > 1) {
        dayStartInRow = dayStartInRow - this.firstDate
      }
      var arrWeek = []
      for (var i = 1; i <= 7; i++) {
        if (week === 1 && i <= this.firstDate) {
          for (var j = 1; j <= this.firstDate; j++) {
            arrWeek.push('')
            i++
          }
        }

        if (dayStartInRow <= this.sumDayInMonth) {
          arrWeek.push(dayStartInRow)
          dayStartInRow++
        } else {
          arrWeek.push('')
        }
      }
      return arrWeek
    },
    autoFocusCalendarTab (obj) {
      const date = this.selectedDate
      const month = this.selectingMonth
      const year = this.selectingYear
      const calendarDayDisp = this.calendarDayDisp
      const calendarMonthDisp = this.calendarMonthDisp
      const boolFilter = this.btnFilter[obj.tab]
      const objFilter = obj.calendarTabRows.filter(function (calendarTabRow) {
        return ((calendarMonthDisp) || (calendarDayDisp && parseInt(calendarTabRow.date) === parseInt(date))) &&
               parseInt(calendarTabRow.month) === parseInt(month) &&
               parseInt(calendarTabRow.year) === parseInt(year) &&
               boolFilter
      })
      if (objFilter.length > 0 && this.pcDisp) {
        this.toggleCalendar('calendarTab' + obj.tab.substr(3) + 'Disp')
      }
    },
    filterCalendarTab (obj) {
      const date = this.selectedDate
      const month = this.selectingMonth
      const year = this.selectingYear
      const calendarDayDisp = this.calendarDayDisp
      const calendarMonthDisp = this.calendarMonthDisp
      const boolFilter = this.btnFilter[obj.tab]
      const objFilter = obj.calendarTabRows.filter(function (calendarTabRow) {
        return ((calendarMonthDisp) || (calendarDayDisp && parseInt(calendarTabRow.date) === parseInt(date))) &&
               parseInt(calendarTabRow.month) === parseInt(month) &&
               parseInt(calendarTabRow.year) === parseInt(year) &&
               boolFilter
      })
      this.foundCalendar[obj.tab] = (objFilter.length > 0)
      return objFilter
    },
    getDescHoliday () {
      this.traditionHoliday = this.calendarHoliday.rows
        .filter(dataFilter => (parseInt(dataFilter.month) === this.selectingMonth && dataFilter.typwork === 'T'))
        .reduce((sum, data) => {
          return sum + parseInt(data.date) + ' ' + data.desholdy + ', '
        }, '')
      this.traditionHoliday = this.traditionHoliday.substr(0, this.traditionHoliday.length - 2)
    },
    ...mapMutations({
      setBtnFilter: types.SET_BTN_FILTER,
      setFoundCalendar: types.SET_FOUND_CALENDAR,
      setSelectYear: types.SET_SELECTING_YEAR,
      setSelectMonth: types.SET_SELECTING_MONTH,
      setSelectDate: types.SET_SELECTING_DATE,
      setCalendarMain: types.SET_CALENDAR_MAIN,
      setAddDate: types.SET_ADD_DATE,
      setAddMonth: types.SET_ADD_MONTH,
      toggleCalendar: types.SET_CALENDAR_DISP,
      toggleFilterImage: types.SET_FILTER_IMAGE,
      toggleCalendarSwitch: types.SET_CALENDAR_SWITCH
    }),
    ...mapActions({
      receivedCalendarYear: types.RECEIVED_ALL_CALENDARTAB,
      receivedcalendarTab1: types.RECEIVED_CALENDARTAB1,
      receivedcalendarTab2: types.RECEIVED_CALENDARTAB2,
      receivedcalendarTab3: types.RECEIVED_CALENDARTAB3,
      receivedcalendarTab4: types.RECEIVED_CALENDARTAB4,
      deleteCalendarTab4: types.DELETE_CALENDAR_TAB4,
      postCalendarTab4: types.POST_CALENDAR_TAB4,
      postCalendarTab4Checked: types.POST_CALENDAR_TAB4_CHECKED
    })
  },
  components: {
    mainCalendar,
    CalendarFilter,
    CalendarMenu,
    CalendarFilterPc,
    CalendarMenuPc,
    calendarTab1,
    calendarTab2,
    calendarTab3,
    calendarTab4
  }
}
</script>

<style src="./style.scss" lang='scss'></style>



// WEBPACK FOOTER //
// component.vue?13132eb2